import React from "react";
import { FileText } from "lucide-react";

const S = ({ n, title, children }) => (
  <div className="space-y-1">
    <h3 className="font-head font-semibold">{n}. {title}</h3>
    <p className="text-sm text-muted-foreground leading-relaxed">{children}</p>
  </div>
);

export default function ShippingTerms() {
  return (
    <div className="space-y-6 max-w-2xl" data-testid="shipping-terms-page">
      <div>
        <div className="flex items-center gap-2"><FileText className="w-4 h-4 text-primary" /><span className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Spedizioni</span></div>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-2">Condizioni generali di spedizione</h1>
      </div>

      <div className="space-y-5">
        <S n="1" title="Rimborsi ed etichette">
          Una volta emessa l'etichetta di spedizione, l'importo <strong>non è rimborsabile</strong>. L'unica
          eccezione è il <strong>mancato ritiro da parte del corriere</strong>: in tal caso l'importo pagato viene
          riaccreditato.
        </S>
        <S n="2" title="Contenuto e valore dichiarato">
          Il mittente è tenuto a dichiarare in modo veritiero il <strong>contenuto</strong> e il <strong>valore</strong>
          del pacco. Tali dati sono forniti sotto la sua esclusiva responsabilità e sono utilizzati per la spedizione
          e per l'eventuale copertura assicurativa.
        </S>
        <S n="3" title="Responsabilità sul contenuto">
          La responsabilità di ciò che è contenuto nel collo è integralmente del mittente. Non è consentito spedire
          merci vietate o pericolose secondo le norme del corriere e di legge.
        </S>
        <S n="4" title="Assicurazione (opzionale)">
          L'assicurazione è un'<strong>opzione</strong> proposta dal venditore che l'acquirente può liberamente scegliere se
          accettare. Se selezionata, il premio è pari al <strong>2% del valore dichiarato</strong>, IVA inclusa, e copre
          la spedizione fino a un <strong>valore massimo di € 100,00</strong> (2% di € 100,00 = € 2,00). Le spedizioni con valore
          dichiarato <strong>superiore a € 100,00 non sono assicurabili</strong>. L'indennizzo è subordinato alla veridicità
          dei dati dichiarati.
        </S>
        <S n="5" title="Tempi di consegna">
          I tempi indicati per ciascun corriere sono stimati e non vincolanti; eventuali ritardi del corriere non
          danno diritto al rimborso della spedizione.
        </S>
      </div>
    </div>
  );
}
